import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/pdf-fills']['PUT'];
type Body = ThisApi['body'];

const getPdfFillsForQuestionnaire = async (body: Body): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/pdf-fills', {
    questionnaireId: body.questionnaireIds[0],
  });
  const response = await formsBackendClient.put(path, body);
  return response.data;
};

export default getPdfFillsForQuestionnaire;
